module.exports = __webpack_public_path__ + "img/520x_05_book.2b6e3279.png";